// Legend.js
import { Box, Typography } from "@mui/material";
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

const defaultLegendItems = [
  { color: "#F57C00", label: "Urgent", isIcon: true },
  { color: "#E8F5E9", label: "Invoice Paid" },
  { color: "#ffcccc", label: "Cancelled" },
];

export default function CustomLegend({ customeLegendItems = [] }) {

  // CHECK IF CUSTOME LEGEND ITEMS ARE PROVIDED, ELSE USE DEFAULT
  const legendItems = customeLegendItems.length > 0 ? customeLegendItems : defaultLegendItems;

  return (
    <Box
      sx={{
        display: "flex",
        flexWrap: "wrap",
        gap: 2,
        mb: 2,
      }}
    >
      {legendItems?.map((item, idx) => (
        <Box
          key={idx}
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
          }}
        >
          {item.isIcon ? (
            <WarningAmberIcon sx={{ color: item.color, fontSize: 18 }} />
          ) : (
            <Box
              sx={{
                width: 16,
                height: 16,
                borderRadius: "4px",
                backgroundColor: item.color,
                border: "1px solid #ccc",
              }}
            />
          )}
          <Typography
            variant="body2"
            sx={{ fontFamily: "Inter", fontSize: "0.9rem", color: "#111827" }}
          >
            {item.label}
          </Typography>
        </Box>
      ))}
    </Box>
  );
}
